export function useTimer(
  props = {
    endTime: "02:00",
  },
) {
  const timer = ref("00:00");
  const Ref = ref({ current: "" });
  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);

    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);

    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      timer.value =
        (minutes > 9 ? minutes : "0" + minutes) +
        ":" +
        (seconds > 9 ? seconds : "0" + seconds);
    }
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    timer.value = props.endTime;

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.value.current) clearInterval(Ref.value.current);

    const id = setInterval(() => {
      startTimer(e);
    }, 1000);

    Ref.value.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you want to add more time
    deadline.setSeconds(deadline.getSeconds() + 120);

    return deadline;
  };

  const resetTimer = () => {
    clearInterval(Ref.value.current);

    timer.value = "00:00";
  };

  return {
    timer,
    getDeadTime,
    clearTimer,
    resetTimer,
  };
}
